import React, { useEffect, useState } from "react";

export default function Counter({ end, suffix = "", speed =70, start }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) {
      setCount(0); 
      return;
    }

    let current = 0;
    const interval = setInterval(() => {
      current += 1;

      if (current >= end) {
        setCount(end);
        clearInterval(interval);
      } else {
        setCount(current);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [start, end, speed]);

  return (
    <div className="impact-number">
      {count}
      {suffix}
    </div>
  );
}
